// extracted by mini-css-extract-plugin
export default {"imageWrapper":"KP-z","hovered":"LP-z","hoverImage":"MP-z","mainImage":"NP-z","imageNoBackground":"OP-z","fullSizeImage":"PP-z"};